import React from 'react'

import { Card, CardHeader, CardContent } from '@material-ui/core'

import ActionGroup from '../../../../ActionBar/ActionGroup/ActionGroup'
import DataTable from '../../../../DataTable/DataTable'

const GradeCriteriaContent = ({
  tableTitle,
  tableStructure,
  rowActions,
  gradeList,
  loadingStates,
  openFilterModal,
  pagination,
  pageChanged,
  perPageChanged
}) => {
  return (
    <Card>
      <CardHeader title={<ActionGroup show={['filter']} filterButtonClicked={openFilterModal} />} />
      <CardContent>
        <DataTable
          tableTitle={tableTitle}
          structure={tableStructure}
          rowActions={rowActions}
          data={gradeList}
          loading={loadingStates.includes('records')}
          pagination={pagination}
          pageChange={pageChanged}
          perPageChange={perPageChanged}
        />
      </CardContent>
    </Card>
  )
}

export default GradeCriteriaContent
